module.exports = __webpack_public_path__ + "img/history-p-800.06923c2d.png";